if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.fableSetup();
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      // A variant photo in the packshot list comes to its front, where it is the one shown. A photo
      // on the slider (variant photos are slides when the section does not hide them) is brought
      // into view there. The page itself is never scrolled to the gallery: the sticky add to cart
      // changes variants from anywhere on the page.
      if (this.fablePackshot && this.fablePackshot.contains(activeMedia)) {
        if (prepend) this.fablePackshot.prepend(activeMedia);
      } else if (this.fableSlider && this.fableSlider.contains(activeMedia)) {
        this.fableGoToMedia(activeMedia);
      } else if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      if (this.elements.thumbnails) {
        window.setTimeout(() => activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft }));
      }
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    // Packshot and slider (product-media-gallery.liquid). <fable-carousel> scrolls the slider and
    // runs its arrows; the progress line, the counter and the thumbnail row follow the slide it
    // reports, and a thumbnail brings its slide into view.
    fableSetup() {
      this.fablePackshot = this.querySelector('.fable-pdp__packshot');
      this.fableSlider = this.querySelector('.fable-pdp__slider');
      if (!this.fableSlider) return;
      this.fableProgress = this.querySelector('.fable-pdp__progress');
      this.fableCounter = this.querySelector('.fable-pdp__counter-current');
      this.fableThumbs = Array.from(this.querySelectorAll('.fable-pdp__thumb'));

      this.fableSlider.addEventListener('fable-carousel:change', (event) => this.fableShowSlide(event.detail.index));
      this.fableThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (typeof this.fableSlider.goTo === 'function') this.fableSlider.goTo(Number(thumb.dataset.index));
        });
      });
    }

    fableShowSlide(index) {
      if (this.fableProgress) this.fableProgress.style.setProperty('--fable-slide', index);
      if (this.fableCounter) this.fableCounter.textContent = index + 1;
      this.fableThumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', Number(thumb.dataset.index) === index ? 'true' : 'false');
      });
    }

    fableGoToMedia(media) {
      const slider = this.fableSlider;
      if (!slider || !Array.isArray(slider.pages)) return;
      const index = slider.pages.findIndex((page) => page.slide === media);
      if (index > -1) slider.goTo(index);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
